export const NAME = 'rates';
export const LEVEL_ONE = 'RatesComponentReducer';
